module.exports = __webpack_public_path__ + "static/img/EWallet-Funding.eb161f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/backoffice/EWallet-Funding.png
// module id = 1Fvs
// module chunks = 0